import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import Amplify from '@aws-amplify/core';
import Storage from '@aws-amplify/storage';

// default using agent for now

Amplify.configure({
  Auth: {
    identityPoolId: environment.aws.agent.cognito.identity_pool.identity_pool_id,
    identityPoolRegion: environment.aws.agent.cognito.identity_pool.region,
    region: environment.aws.agent.cognito.user_pool.region,
    userPoolId: environment.aws.agent.cognito.user_pool.user_pool_id,
    userPoolWebClientId: environment.aws.agent.cognito.user_pool.app_client_id
  },
  // oauth: {
  //   domain: environment.aws.cognito.oauth.domain,
  //   scope: environment.aws.cognito.oauth.scope,
  //   redirectSignIn: environment.aws.cognito.oauth.redirectSignIn,
  //   redirectSignOut: environment.aws.cognito.oauth.redirectSignOut,
  //   responseType: environment.aws.cognito.oauth.responseType
  // }
});

Storage.configure({
  AWSS3: {
    bucket: environment.aws.s3.bucket,
    region: environment.aws.s3.region
  }
})

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
